export enum ATTRIBUTE_TYPE {
  NA = 'NA',
  ARRAY = 'ARRAY',
  CHANNEL = 'CHANNEL',
  OPTIONAL = 'OPTIONAL'
}
